import appContent from './content';
let {
  ArticlesIndexer,
  ArticleBySlug,
  MediaIndexer,
  FactionSettingsByFaction,
  ShopIndexer,
  GlobalSettings,
  TwitchConfig
} = appContent.classes;

export default async function (view, params, repo) {
  let content = {globalSettings: await GlobalSettings.get(repo)};
  switch (view) {
    case 'home':
      content.products = await repo.fetchContentAtPath(ShopIndexer.indexFileName, ShopIndexer);
      content.articles = await repo.fetchContentAtPath(ArticlesIndexer.indexFileName, ArticlesIndexer);
      break;
    case 'news':
      content.articles = await repo.fetchContentAtPath(ArticlesIndexer.indexFileName, ArticlesIndexer);
      content.twitchConfig = await TwitchConfig.get(repo);
      break;
    case 'media':
      content.mediaItems = await repo.fetchContentAtPath(MediaIndexer.indexFileName, MediaIndexer);
      break;
    case 'article':
      content.article = await ArticleBySlug.get(repo, params.slug);
      break;
    case 'faction':
      content.factionSettings = await FactionSettingsByFaction.get(repo, params.faction);
      break;
    case 'buy':
      content.products = await repo.fetchContentAtPath(ShopIndexer.indexFileName, ShopIndexer);
      break;
    // case 'clans-search':
    //   content.clanConfig = await repo.fetchContentAtPath(ClanConfig.path, ClanConfig);
    //   content.searchLabelFilters = await repo.fetchContentAtPath(SearchLabelFilters.path, SearchLabelFilters);
    //   break;
    // case 'clan-view':
    //   content.clanConfig = await repo.fetchContentAtPath(ClanConfig.path, ClanConfig);
    //   content.searchLabelFilters = await repo.fetchContentAtPath(SearchLabelFilters.path, SearchLabelFilters);
      //break;
  }
  return content;
}



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/loader.js